import isEqual from 'lodash/isEqual'
import isString from 'lodash/isString'
import { compose, withState, withProps, lifecycle } from 'recompose'

export default (options = {}) => {
  const {
    predicate = isString,
  } = options
  return compose(
    withState('tempState', 'setTempState', ({ value }) => value),
    lifecycle({
      componentWillReceiveProps(nextProps) {
        const { value } = nextProps
        if (!isEqual(this.props.value, value) && predicate(value)) {
          this.props.setTempState(value)
        }
      },
    }),
    withProps(
      ({ tempState, setTempState, onChange }) => ({
        value: tempState,
        onChange: (val) => setTempState(val),
        onSubmit: () => onChange(tempState),
        onRawChange: onChange,
        createOnSubmit: (cb) => cb(tempState, onChange),
      }),
    ),
  )
}



// WEBPACK FOOTER //
// ./src/hocs/bases/withTemporaryForm.js